
// This should be replaced by the user's Client ID in a real production env, 
// or handled via an input. For this demo, we will prompt the user or use a placeholder 
// if they don't provide one, but it won't work without a valid one.
// Since we cannot hardcode a client ID, we will assume the user inputs it or it is in env.

export const CLIENT_ID = '411683088668-40hm3jkq43pcdblrt5ecibvjc8svj636.apps.googleusercontent.com';
export const SCOPES = 'https://www.googleapis.com/auth/drive.file openid profile email';
export const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'];

// The Gemini credential is server-only and intentionally absent here — see
// api/ai/searchTags.ts and api/ai/analyze.ts.
